import { FC } from 'react';
import { NavigationLink } from '../components/NavigationLink';
import { useI18n } from '#/hooks/useI18n';
import { Can } from '#/components/roles/Can';
import { SectionProps } from '../Sections';
import { Private } from '#/containers/router/routes/Private';

export const AffiliationMarketplace: FC<SectionProps> = ({ onClickItem, isMobile, depth }) => {
  const { t } = useI18n();
  return (
    <Can hasRoles={['admin']} inDefaultOrganization>
      <NavigationLink
        to={Private.AFFILIATION_MARKETPLACE.route}
        icon="marketplace"
        depth={depth}
        isMobile={isMobile}
        title={t('asideNavigation.affiliationMarketplace')}
        onClick={onClickItem}
      />
    </Can>
  );
};
